import React from 'react';
import PropTypes from 'prop-types';
import CustomLink from '../Link';
import BackToPG from '../../Icons/BackToPG';
import styles from '../Navigation.css';
import { trackPUAnalytics } from '../../../services/Mixpanel';

const NavigationBarMiddleContainer = ({
  active,
  setActive,
  isMobile,
  links,
  pgHomeLink,
}) => {
  const trackAnalytics = (tab) => trackPUAnalytics('PathwayU:Select Tab', {
    tab,
  });

  const backToPG = () => {
    if (pgHomeLink) {
      trackPUAnalytics('PathwayU:Land', {
        clickButton: 'Home',
      });
      window.location.href = pgHomeLink;
    }
  };

  if (isMobile) return null;

  return (
    <React.Fragment>
      {pgHomeLink ? (
        <button onClick={backToPG} className={styles.backToPG}>
          <BackToPG />
          Home
        </button>
      ) : null}
      <div className={styles.verticalLineWrapper}>
        <div className={styles.verticalLine} />
      </div>
      <ul className={styles.navList}>
        {links.map(({ id, path, name, isExact }) => (
          <li key={id}>
            <CustomLink
              key={id}
              identifier={id}
              to={path}
              exact={isExact}
              active={active === id}
              setActive={setActive}
              trackAnalytics={() => trackAnalytics(name)}
            >
              {name}
            </CustomLink>
          </li>
        ))}
      </ul>
    </React.Fragment>
  );
};

NavigationBarMiddleContainer.propTypes = {
  active: PropTypes.string,
  setActive: PropTypes.func,
  isMobile: PropTypes.bool,
  links:
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        path: PropTypes.string,
        isExact: PropTypes.bool,
      }),
    ),
  pgHomeLink: PropTypes.oneOfType(
    [PropTypes.string, PropTypes.oneOf([null])],
  ),
};

export default NavigationBarMiddleContainer;



// WEBPACK FOOTER //
// ./src/client/Components/Navigation/components/NavigationBarMiddleContainer.js